/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import currencySymbol from 'currency-symbol';
import defaults from '../../utils/defaults';
import { shoppableElementDefaults } from '../../utils/shoppableConfigs';

const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

const namespaced = true;
const state = () => ({
  // we may have a data provider in the future
  // for name we are hardcoding values and user will change in producer
  selectedProduct: {
    id: 1,
    name: 'Super Cool Product Name Placeholder',
    currentPrice: 0,
    currency: 'USD',
    url: 'https://tagboard.com',
    image: `${TGB_ASSETS_URL}/placeholders/placeholder-square.svg`,
  },
  termsText: 'We may earn a commission if you purchase through this QR code. All prices are as is and are subject to change.',
  namespace: '', // the element id,
});

const getters = {
  // using getters to format selected product because we may have a data provider in the future
  // we we do that we'll likely look up the product by id and so by using the getter,
  // there will be no need to change the component
  getProduct: (state) => state.selectedProduct,
  getFormattedProductPrice: (state, getters) => currencySymbol.symbol(getters.getProduct.currency)
  + getters.getProduct.currentPrice.toFixed(2),
  getTermsText: (state) => state.termsText,

};

const actions = {
  setNamespace({ commit }, payload) {
    commit('SET_NAMESPACE', payload);
  },
  async createShoppableTemplate({ state, getters, dispatch }, payload) {
    const { selectedElements } = payload;

    const permalink = getters.getProduct.url;
    const provider = state.namespace;
    const allChildElements = shoppableElementDefaults(provider, permalink);
    const childElements = selectedElements.map((element) => allChildElements[element]);

    const settings = {
      ...defaults.shoppable,
      id: provider,
    };

    // add the parent element
    await dispatch(
      'graphicsTemplate/addNewElement',
      {
        value: {
          type: 'shoppable',
          settings,
          isGroup: true,
        },
      },
      {
        root: true,
      },
    );

    // add the child elements
    const promises = childElements.reverse()
      .map((el, index) => {
        // skip group recalculation until last element
        el.value.skipGroupRecalculation = true;

        // if we've added the last element, we want to recalculate the group
        // Since we don't know the order elements will be added,
        // we need to set this flag on the last element here
        if (index === childElements.length - 1) {
          el.value.skipGroupRecalculation = false;
        }
        return dispatch('graphicsTemplate/addNewElement', el, { root: true });
      });
    // wait for all the child elements to be added
    await Promise.all(promises);

    // nextTick doesn't wait long enough here. 0ms timeout is a hack to wait for the dom to update
    // we have to do this otherwise the translateDrag (works outside of vue)
    // remains enabled on the wrong element (see `Group.Vue removeEditting` method)
    setTimeout(() => {
      dispatch('clearSelectedGroups', null, { root: true });
      dispatch('setTextEditing', false, { root: true });
      dispatch('selectElements', [], { root: true });

      dispatch('selectElements', [provider], { root: true });
    }, 0);
  },
};

const mutations = {
  SET_NAMESPACE(state, payload) {
    state.namespace = payload;
  },
};

export default {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
